import { render, staticRenderFns } from "./compatibilityTips.vue?vue&type=template&id=5ac878fa"
import script from "./compatibilityTips.vue?vue&type=script&lang=ts"
export * from "./compatibilityTips.vue?vue&type=script&lang=ts"
import style0 from "./compatibilityTips.vue?vue&type=style&index=0&id=5ac878fa&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./compatibilityTips.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports